import { isDevEnv } from './isRuntimeEnv'

const DEV_ENV = isDevEnv()

/**
 * writes a logging message to the browser console
 * @param message logging message
 */
export function debugLog(...message: unknown[]): void {
  if (DEV_ENV) {
    console.log(...message)
  }
}
